module.exports = __webpack_public_path__ + "icons.faff92145777a3cbaf8e.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/icons.woff
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/icons.woff
// module chunks = styles